import { takeEvery } from 'redux-saga/effects';
import { qcsSyncCreateResource, qcsSyncDeleteResource } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import * as actions from './actions';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'job statues',
  resourceBaseUrl: '/job-statuses',
  ...props,
});

function* createJobStatusActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.createJobStatusSuccess,
    failureAction: actions.createJobStatusFailure,
  });
  yield takeEvery(actions.createJobStatus, qcsSyncCreateResource, config);
}

function* deleteJobStatusActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.deleteJobStatusSuccess,
    failureAction: actions.deleteJobStatusFailure,
  });
  yield takeEvery(actions.deleteJobStatus, qcsSyncDeleteResource, config);
}

export default [
  createJobStatusActionWatcher,
  deleteJobStatusActionWatcher,
];
